import {commonActions} from '../../actions/commonActions';
import {bankSetList} from '../../actions/financialActions';
import {connect} from 'react-redux';
import List from '../../components/financial/BankList';
import {API_FETCH} from '../../services/FetchService';



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = (value) => {
    return (dispatch, getState) => {
        API_FETCH.get('financial/bank-account',{params: value}).then(list => {
            dispatch(bankSetList(list.data.result.lists));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.financial.bankList,
        common       : state.common,
        initialValues: state.service.targetItem
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
